import { cn } from "@nextui-org/react";

export function NavBarItem({ children, href, active, target, className }) {
  return (
    <div
      className={cn(
        "flex items-center justify-center cursor-pointer  text-sm leading-[110%] px-4 py-2 rounded-md  hover:bg-neutral-800 hover:text-white/80 text-white hover:shadow-[0px_1px_0px_0px_#FFFFFF20_inset] transition duration-200",
        active ? "text-fuchsia-600 hover:text-fuchsia-600" : "",
        className
      )}
    >
      {children}
    </div>
  );
}
